import {AbstractPage} from "./AbstractPage";
import {JqueryApp} from "./JqueryApp";
//import * as ProgressBar from "progressbar.js"
import * as misc from "./utils/misc";
import {logger} from "./utils/Log";
import {PaymentResponse} from "./structs/PaymentResponse";
import {CreditCard} from "./CreditCard";
import {GatewaySa} from "./gateway/GatewaySa";
import {store} from "./utils/Store";
import {Payment} from "./structs/Payment";
import {clearInterval} from "timers";
import {getBetween} from "./utils/misc";
import {GatewayUs} from "./gateway/GatewayUs";
import {Fingerprint} from "./Fingerprint";


export class Pay extends AbstractPage {
    //protected payment: PaymentResponse = null; // the latest payment status from API
    protected payment: Payment = null;
    protected gatewayUs: GatewayUs = null;
    protected gatewaySa: GatewaySa = null;
    protected cards: CreditCard = null;
    protected customerCountUpdateTimerID: number = 0;

    constructor(app: JqueryApp) {
        super(app);

        const config = this.app.getConfig();
        if (config.payment.gateway === "st")
            this.gatewayUs = new GatewayUs(app);
        else if (config.payment.gateway === "ps")
            this.gatewaySa = new GatewaySa(app);
        else
            this.cards = new CreditCard(app); // TODO only load on certain gateways

        if (window.Pace !== undefined) {
            /*
            window.Pace.options = { // must be done before Pace is started
                ajax: false
            }*/
            window.Pace.options.ajax = false;
            //window.Pace.restart();
        }

        this.app.$(window).on("load", ($) => {
            //this.addButtonLinkClass();
            /*
            if (this.app.$(".pay-preloader").length > 0) {
                this.app.$(".pay-preloader").fadeOut("slow");
            }
            this.webHelpers.preloadImages(config.payment.successPayImage, config.payment.successPayImageFinal);
             */
            if (this.cards !== null)
                this.cards.styleCards();
            if (this.gatewayUs !== null)
                this.gatewayUs.connectForm();
            else if (this.gatewaySa !== null)
                this.gatewaySa.connectForm();
            this.connectReturnToMerchantButton();
            this.listenPaymentReceivedFrame();
        });
        this.app.$(() => { // jQuery 3.0 "document.ready"
            this.addEventListeners();
            this.payment = config.payment;
            if (config.payment && config.payment.status === "PAID")
                this.sendPaidFrameMessage();
            this.startCustomerCountUpdateTimer();

            setTimeout(() => { // give browser some time to load other things first
                const finger = new Fingerprint(this.app);
                finger.load();
            }, 2000);
        });
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected addEventListeners() {
        //if (this.app.$("#pay-qrcode-form").length !== 0)
            //this.addPaymentFormEvents(this.app.$("#pay-qrcode-form").eq(0)); // the form after the order has been placed
        this.hightlightDescriptor();
    }

    protected hightlightDescriptor(): void {
        let html = this.app.$(".charged-pay").html();
        if (html === undefined)
            return;
        let descriptor = getBetween(html, '"descriptor":"', '"');
        if (descriptor === false)
            return;
        html = html.replace(descriptor, `<span class="pay-descriptor">${descriptor}</span>`);
        this.app.$(".charged-pay").html(html);
    }


    /*
    protected showPaymentReceived() {
        //if (this.fullyPaid === true)
            //return; // already updated
        //this.fullyPaid = true;

        const config = this.app.getConfig();
        const tr = this.app.getTr();

        config.payment.status = "PAID";
        //clearTimeout(this.checkLocalPaymentTimerID);
        let successImage = window.document.createElement("img");
        successImage.src = config.payment.successPayImage;
        successImage.alt = tr.get("paid");
        successImage.id = "pay-success-image-animated";
        this.addSuccessImageProperties(successImage);
        setTimeout(() => {
            this.showFinalPaidImage(); // TODO remove?
        }, 1300);

        this.app.$("#pay-payment-status").text(tr.get("paid"));
        this.app.$("#pay-payment-pending, #pay-payment-options, #pay-pay-instructions").fadeOut("slow");
        //this.app.$("#pay-qr-code").replaceWith(successImage);

        this.sendPaidFrameMessage();
    }
    */

    protected sendPaidFrameMessage() {
        const config = this.app.getConfig();
        if (this.payment === null) {
            //console.warn("Generating mock payment. This shouldn't happen in production!");
            //this.payment = PaymentResponse.generateMockPayment(config.payment.token);
            console.error("Unable to find payment config object")
            return;
        }

        // only fire once
        const paidKey = "paid-" + this.payment.token;
        if (store.getItem(paidKey) == true)
            return;
        store.setItem(paidKey, true);

        /* // unreliable on confirm page
        if (config.fullPage === true) {
            console.debug("Skipped sending 'paid' message in fullPage mode");
            return;
        }
         */
        if (window.parent === window.self) {
            console.debug("Skipped sending 'paid' message without parent");
            return; // should be same as fullPage === true
        }
        //let targetOrigin = config.ref || "*"; // send to all windows as fallback only
        let targetOrigin = "*"; // send to all windows as we likely navigated in the frame
        //console.debug("Sending 'paid' message to origin: %s", targetOrigin);
        window.parent.postMessage({
            'func': 'onVpayPaid',
            'data': this.payment,
        }, targetOrigin);
    }

    protected connectReturnToMerchantButton() {
        const btn = this.app.$("#return-merchant");
        if (btn.length === 0)
            return;
        else if (window.parent === window.self) {
            btn.fadeOut("fast");
            console.log("Disabling return to merchant button as we are not in an iframe");
            return;
        }

        // TODO cancel click timer?
        btn.on("click", (e) => {
            this.disableReturnToMerchantButtonTimer();
            let targetOrigin = "*";
            window.parent.postMessage({
                'func': 'onVpayReturnToMerchant',
                'data': {},
            }, targetOrigin);
        });

        // only auto reload once
        const reloadKey = "reload-" + this.payment.token;
        if (store.getItem(reloadKey) == true)
            return;
        store.setItem(reloadKey, true);
        setTimeout(() => {
            btn.click();
            },
            30*1000);
    }

    protected listenPaymentReceivedFrame() {
        //const gatewayOrigin = "https://verified-store.org"; // ignore messages from other frames
        const gatewayOrigin = "verified";

        const onMessage = (event) => {
            //if (event.origin !== gatewayOrigin) {
            if (event.origin.indexOf(gatewayOrigin) === -1) {
                return;
            }

            let data = event.data;
            if (data.func === undefined)
                return;
            if (data.func === "onVpayStorePaid") {
                //const payment = data.data;
                //window.location.assign(payment.return_url);
                this.app.$("#vpay-frame-wrap").fadeOut();
            }
            else
                console.debug("Received unknwon Vpay message type: %s", data.func);
        }

        if (window.addEventListener) {
            window.addEventListener("message", onMessage, false);
        }
        else if ((window as any).attachEvent) {
            (window as any).attachEvent("onmessage", onMessage, false);
        }
    }

    protected disableReturnToMerchantButtonTimer() {
        const confirmButton = $('#return-merchant');
        confirmButton.attr('disabled', "true");
        setTimeout(() => {
            confirmButton.removeAttr('disabled');
        }, 9000);
    }

    protected startCustomerCountUpdateTimer() {
        if (this.customerCountUpdateTimerID !== 0)
            return;
        this.app.$("#customerCount").text(0.9 * this.app.getConfig().customerCount);
        this.customerCountUpdateTimerID = window.setInterval(() => {
            this.updateCustomerCount();
        }, 150);
    }

    protected updateCustomerCount() {
        const config = this.app.getConfig();
        const currentCount = parseInt(this.app.$("#customerCount").text()) || 0;
        if (currentCount >= config.customerCount) {
            window.clearInterval(this.customerCountUpdateTimerID);
            return;
        }
        const step = Math.floor(config.customerCount / 120)
        let nextCount = currentCount + Math.floor(Math.random() * step);
        if (nextCount > config.customerCount)
            nextCount = config.customerCount;
        this.app.$("#customerCount").text(nextCount);
    }

    /*
    protected showFinalPaidImage() {
        const config = this.app.getConfig();
        //let successImageFinal: HTMLImageElement = Object.assign(this.slpPayments.window.document.createElement("img"), successImage); // doesn't copy attributes of native elements
        let successImageFinal = window.document.createElement("img");
        successImageFinal.src = config.payment.successPayImageFinal;
        //successImageFinal.alt = this.slpPayments.getConfig().paidTxt;
        successImageFinal.id = "pay-success-image";
        this.addSuccessImageProperties(successImageFinal);
        this.app.$("#pay-success-image-animated, #pay-qr-code").replaceWith(successImageFinal);

        // redirect customer back to store
        logger.verbose("Returning customer to URL: %s", config.payment.returnUrl);
        if (!config.payment.returnUrl || config.payment.returnUrl.toLowerCase().indexOf("http") !== 0)
            return;
        window.location.replace(config.payment.returnUrl);
    }
     */

    /*
    protected addSuccessImageProperties(image: HTMLImageElement) {
        image.style.maxWidth = "300px";
        image.style.maxHeight = "300px";
        image.style.width = "100%";
        image.style.display = "block";
        image.className = "pay-center";
    }
     */
}
